/**
 * Display helpers of the receiving screens (batch 8 T12c2, #3033). Display only: nothing here decides a quantity or a price.
 */

const DECIMAL = /^(-?)(\d{1,15})(?:\.(\d{1,6}))?$/;

/**
 * Exact cost text in CENTS (`"1234.5678"`, as the server sends cost layers) as euros: the decimal point moves two places, with
 * no float in between, so no digit is lost or rounded. At least two decimals; trailing zeros beyond that are dropped.
 * `"800.0000"` is `8,00 €`. Anything that is not a plain decimal is returned as `null` (never guessed).
 */
export function centsTextToEuros(text: string, language: string): string | null {
  const match = DECIMAL.exec(text.trim());
  if (!match) return null;
  const sign = match[1] === '-' && /[1-9]/.test(text) ? '-' : '';
  const whole = (match[2] ?? '0').padStart(3, '0');
  const digits = `${whole}${match[3] ?? ''}`;
  const point = digits.length - 2 - (match[3]?.length ?? 0);
  const integerPart = digits.slice(0, point);
  const fraction = digits.slice(point).padEnd(2, '0');
  const trimmed = fraction.replace(/0+$/, '').padEnd(2, '0');
  const separator = language.startsWith('fi') || language.startsWith('sv') ? ',' : '.';
  return `${sign}${integerPart.replace(/^0+(?=\d)/, '')}${separator}${trimmed}\u00A0€`;
}

export function formatDateTime(value: string, language: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(language, { dateStyle: 'short', timeStyle: 'short' }).format(date);
}
